"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1924],{

/***/ 11924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "config": function() { return /* binding */ config_config; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
// EXTERNAL MODULE: ./sites/common/config.ts
var config = __webpack_require__(35333);
// EXTERNAL MODULE: ./sites/common/fields.ts
var fields = __webpack_require__(50384);
;// CONCATENATED MODULE: ./sites/gb/fields.ts



var GBFieldProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields/* commonFieldsProps */.I), {
    phone: {
        fieldType: "input",
        pattern: "^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$"
    },
    phoneNumber: {
        fieldType: "input",
        pattern: "^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$"
    },
    password: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newPassword: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    currentPassword: {
        fieldType: "password",
        maxLength: 255
    },
    passwordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newPasswordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newResetPassword: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    newResetPasswordConfirmation: {
        fieldType: "password",
        validations: [
            "password"
        ],
        maxLength: 255
    },
    cancelLink: {
        fieldType: "link",
        href: "/account"
    },
    countryCode: {
        fieldType: "dropdown",
        validations: [],
        disabled: true,
        options: [
            {
                label: "United Kingdom",
                value: "GB"
            }
        ]
    },
    streetNumber: {
        fieldType: "google-address-look-up",
        mapAddressLookupResultsToFormValues: [
            {
                resultKey: "streetNumber",
                formKey: "streetNumber"
            },
            {
                resultKey: "street",
                formKey: "address1"
            },
            {
                resultKey: "city",
                formKey: "city"
            },
            {
                resultKey: "postalCode",
                formKey: "postalCode"
            }, 
        ],
        validateOnAddressLookupSelect: false,
        maxLength: 30,
        submitOnUpdate: false,
        validations: [
            "latinLettersOnly"
        ]
    },
    postalCode: {
        fieldType: "input",
        autoCapitalize: "characters",
        minLength: 4,
        maxLength: 10,
        validations: [
            "postalCode"
        ]
    },
    billingPostalCode: {
        fieldType: "input",
        autoCapitalize: "characters",
        minLength: 4,
        maxLength: 10,
        pattern: "^(([gG][iI][rR] {0,}0[aA]{2})|(([aA][sS][cC][nN]|[sS][tT][hH][lL]|[tT][dD][cC][uU]|[bB][bB][nN][dD]|[bB][iI][qQ][qQ]|[fF][iI][qQ][qQ]|[pP][cC][rR][nN]|[sS][iI][qQ][qQ]|[iT][kK][cC][aA]) {0,}1[zZ]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yxA-HK-XY]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$"
    },
    firstName: {
        fieldType: "input",
        validations: [
            "englishLettersOnly"
        ],
        maxLength: 30
    },
    lastName: {
        fieldType: "input",
        validations: [
            "englishLettersOnly"
        ],
        maxLength: 30
    },
    companyName: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    address1: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    address2: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    },
    city: {
        fieldType: "input",
        validations: [
            "latinLettersOnly"
        ],
        maxLength: 50
    }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./sites/common/forms.ts
var common_forms = __webpack_require__(68192);
;// CONCATENATED MODULE: ./sites/gb/forms.ts




var addressForm = [
    [
        {
            name: "firstName",
            type: "input",
            required: true
        },
        {
            name: "lastName",
            type: "input",
            required: true
        }, 
    ],
    // comment for the moment
    // [{ name: 'companyName', type: 'input' }],
    [
        // this line is not required for the new quick address form we'll keep it commented untill make sure is definitive
        // { name: 'streetNumber', type: 'google-address-look-up', required: false },
        {
            name: "address1",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "address2",
            type: "input"
        }
    ],
    [
        {
            name: "city",
            type: "input",
            required: true
        },
        {
            name: "postalCode",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "countryCode",
            type: "dropdown"
        }
    ], 
];
var GBForms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common_forms/* commonForms */.C), {
    accountAddress: [
        [
            {
                name: "title",
                type: "input",
                required: true
            }
        ], 
    ].concat((0,_to_consumable_array/* default */.Z)(addressForm), [
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }
        ],
        [
            {
                name: "preferred",
                type: "checkbox"
            }
        ], 
    ]),
    checkoutAddress: (0,_to_consumable_array/* default */.Z)(addressForm),
    checkoutContactInfo: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            },
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }, 
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ], 
    ],
    checkoutContactInfoNoSubscription: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            },
            {
                name: "phone",
                type: "input",
                inputType: "tel"
            }, 
        ], 
    ],
    createAccountInConfirmation: [
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "passwordConfirmation",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "register",
                type: "button",
                buttonType: "submit"
            },
            {
                name: "blank",
                type: "blank"
            }, 
        ], 
    ],
    editProfile: [
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    changePassword: [
        [
            {
                name: "currentPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newPasswordConfirmation",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    resetPassword: [
        [
            {
                name: "newResetPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newResetPasswordConfirmation",
                type: "password",
                required: true
            }, 
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            },
            {
                name: "cancelLink",
                type: "link"
            }, 
        ], 
    ]
});

;// CONCATENATED MODULE: ./sites/gb/states.ts
var gbStates = [
    {
        name: "Aberdeenshire",
        value: "Aberdeenshire"
    },
    {
        name: "Angus",
        value: "Angus"
    },
    {
        name: "Argyll",
        value: "Argyll"
    },
    {
        name: "Avon",
        value: "Avon"
    },
    {
        name: "Ayrshire",
        value: "Ayrshire"
    },
    {
        name: "Banffshire",
        value: "Banffshire"
    },
    {
        name: "Bedfordshire",
        value: "Bedfordshire"
    },
    {
        name: "Berkshire",
        value: "Berkshire"
    },
    {
        name: "Berwickshire",
        value: "Berwickshire"
    },
    {
        name: "Buckinghamshire",
        value: "Buckinghamshire"
    },
    {
        name: "Caithness",
        value: "Caithness"
    },
    {
        name: "Cambridgeshire",
        value: "Cambridgeshire"
    },
    {
        name: "Cheshire",
        value: "Cheshire"
    },
    {
        name: "Clackmannanshire",
        value: "Clackmannanshire"
    },
    {
        name: "Cleveland",
        value: "Cleveland"
    },
    {
        name: "Clwyd",
        value: "Clwyd"
    },
    {
        name: "Cornwall",
        value: "Cornwall"
    },
    {
        name: "County Antrim",
        value: "County Antrim"
    },
    {
        name: "County Armagh",
        value: "County Armagh"
    },
    {
        name: "County Down",
        value: "County Down"
    },
    {
        name: "County Durham",
        value: "County Durham"
    },
    {
        name: "County Fermanagh",
        value: "County Fermanagh"
    },
    {
        name: "County Londonderry",
        value: "County Londonderry"
    },
    {
        name: "County Tyrone",
        value: "County Tyrone"
    },
    {
        name: "Cumbria",
        value: "Cumbria"
    },
    {
        name: "Derbyshire",
        value: "Derbyshire"
    },
    {
        name: "Devon",
        value: "Devon"
    },
    {
        name: "Dorset",
        value: "Dorset"
    },
    {
        name: "Dumfriesshire",
        value: "Dumfriesshire"
    },
    {
        name: "Dunbartonshire",
        value: "Dunbartonshire"
    },
    {
        name: "Dyfed",
        value: "Dyfed"
    },
    {
        name: "East Lothian",
        value: "East Lothian"
    },
    {
        name: "East Sussex",
        value: "East Sussex"
    },
    {
        name: "Essex",
        value: "Essex"
    },
    {
        name: "Fife",
        value: "Fife"
    },
    {
        name: "Gloucestershire",
        value: "Gloucestershire"
    },
    {
        name: "Gwent",
        value: "Gwent"
    },
    {
        name: "Gwynedd",
        value: "Gwynedd"
    },
    {
        name: "Hampshire",
        value: "Hampshire"
    },
    {
        name: "Herefordshire",
        value: "Herefordshire"
    },
    {
        name: "Hertfordshire",
        value: "Hertfordshire"
    },
    {
        name: "Inverness-shire",
        value: "Inverness-shire"
    },
    {
        name: "Isle of Arran",
        value: "Isle of Arran"
    },
    {
        name: "Isle of Barra",
        value: "Isle of Barra"
    },
    {
        name: "Isle of Benbecula",
        value: "Isle of Benbecula"
    },
    {
        name: "Isle of Bute",
        value: "Isle of Bute"
    },
    {
        name: "Isle of Canna",
        value: "Isle of Canna"
    },
    {
        name: "Isle of Coll",
        value: "Isle of Coll"
    },
    {
        name: "Isle of Colonsay",
        value: "Isle of Colonsay"
    },
    {
        name: "Isle of Cumbrae",
        value: "Isle of Cumbrae"
    },
    {
        name: "Isle of Eigg",
        value: "Isle of Eigg"
    },
    {
        name: "Isle of Gigha",
        value: "Isle of Gigha"
    },
    {
        name: "Isle of Harris",
        value: "Isle of Harris"
    },
    {
        name: "Isle of Iona",
        value: "Isle of Iona"
    },
    {
        name: "Isle of Islay",
        value: "Isle of Islay"
    },
    {
        name: "Isle of Jura",
        value: "Isle of Jura"
    },
    {
        name: "Isle of Lewis",
        value: "Isle of Lewis"
    },
    {
        name: "Isle of Mull",
        value: "Isle of Mull"
    },
    {
        name: "Isle of North Uist",
        value: "Isle of North Uist"
    },
    {
        name: "Isle of Rhum",
        value: "Isle of Rhum"
    },
    {
        name: "Isle of Scalpay",
        value: "Isle of Scalpay"
    },
    {
        name: "Isle of Skye",
        value: "Isle of Skye"
    },
    {
        name: "Isle of South Uist",
        value: "Isle of South Uist"
    },
    {
        name: "Isle of Tiree",
        value: "Isle of Tiree"
    },
    {
        name: "Isle of Wight",
        value: "Isle of Wight"
    },
    {
        name: "Kent",
        value: "Kent"
    },
    {
        name: "Kincardineshire",
        value: "Kincardineshire"
    },
    {
        name: "Kinross-shire",
        value: "Kinross-shire"
    },
    {
        name: "Kirkcudbrightshire",
        value: "Kirkcudbrightshire"
    },
    {
        name: "Lanarkshire",
        value: "Lanarkshire"
    },
    {
        name: "Lancashire",
        value: "Lancashire"
    },
    {
        name: "Leicestershire",
        value: "Leicestershire"
    },
    {
        name: "Lincolnshire",
        value: "Lincolnshire"
    },
    {
        name: "London",
        value: "London"
    },
    {
        name: "Merseyside",
        value: "Merseyside"
    },
    {
        name: "Mid Glamorgan",
        value: "Mid Glamorgan"
    },
    {
        name: "Middlesex",
        value: "Middlesex"
    },
    {
        name: "Midlothian",
        value: "Midlothian"
    },
    {
        name: "Morayshire",
        value: "Morayshire"
    },
    {
        name: "Nairnshire",
        value: "Nairnshire"
    },
    {
        name: "Norfolk",
        value: "Norfolk"
    },
    {
        name: "North Humberside",
        value: "North Humberside"
    },
    {
        name: "North Yorkshire",
        value: "North Yorkshire"
    },
    {
        name: "Northamptonshire",
        value: "Northamptonshire"
    },
    {
        name: "Northumberland",
        value: "Northumberland"
    },
    {
        name: "Nottinghamshire",
        value: "Nottinghamshire"
    },
    {
        name: "Orkney",
        value: "Orkney"
    },
    {
        name: "Oxfordshire",
        value: "Oxfordshire"
    },
    {
        name: "Peeblesshire",
        value: "Peeblesshire"
    },
    {
        name: "Perthshire",
        value: "Perthshire"
    },
    {
        name: "Powys",
        value: "Powys"
    },
    {
        name: "Renfrewshire",
        value: "Renfrewshire"
    },
    {
        name: "Ross-shire",
        value: "Ross-shire"
    },
    {
        name: "Roxburghshire",
        value: "Roxburghshire"
    },
    {
        name: "Selkirkshire",
        value: "Selkirkshire"
    },
    {
        name: "Shetland",
        value: "Shetland"
    },
    {
        name: "Shropshire",
        value: "Shropshire"
    },
    {
        name: "Somerset",
        value: "Somerset"
    },
    {
        name: "South Glamorgan",
        value: "South Glamorgan"
    },
    {
        name: "South Humberside",
        value: "South Humberside"
    },
    {
        name: "South Yorkshire",
        value: "South Yorkshire"
    },
    {
        name: "Staffordshire",
        value: "Staffordshire"
    },
    {
        name: "Stirlingshire",
        value: "Stirlingshire"
    },
    {
        name: "Suffolk",
        value: "Suffolk"
    },
    {
        name: "Surrey",
        value: "Surrey"
    },
    {
        name: "Sutherland",
        value: "Sutherland"
    },
    {
        name: "Tyne and Wear",
        value: "Tyne and Wear"
    },
    {
        name: "Warwickshire",
        value: "Warwickshire"
    },
    {
        name: "West Glamorgan",
        value: "West Glamorgan"
    },
    {
        name: "West Lothian",
        value: "West Lothian"
    },
    {
        name: "West Midlands",
        value: "West Midlands"
    },
    {
        name: "West Sussex",
        value: "West Sussex"
    },
    {
        name: "West Yorkshire",
        value: "West Yorkshire"
    },
    {
        name: "Wigtownshire",
        value: "Wigtownshire"
    },
    {
        name: "Wiltshire",
        value: "Wiltshire"
    },
    {
        name: "Worcestershire",
        value: "Worcestershire"
    }, 
];

;// CONCATENATED MODULE: ./sites/gb/config.ts
/* provided dependency */ var process = __webpack_require__(27061);
// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files








var config_config = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig), {
    addressCountries: [
        {
            label: "United Kingdom",
            value: constants/* SUPPORTED_COUNTRY.GB */.bM.GB
        }
    ],
    addressFormat: [
        [
            "firstName",
            "lastName"
        ],
        [
            "address1",
            "address2"
        ],
        [
            "city"
        ],
        [
            "postalCode"
        ],
        [
            "countryCode"
        ], 
    ],
    addressFormatOneLiner: "@{firstName} @{lastName}, @{address1} @{address2} @{city}, @{postalCode} @{countryCode}",
    addressSearch: {
        billing: [
            "GB"
        ],
        shipping: [
            "GB"
        ]
    },
    addressStates: {
        GB: gbStates
    },
    analytics: {
        releaseVersion: "United Kingdom | ".concat(process.env.VERSION)
    },
    applePaySupportedNetworks: [
        "visa",
        "masterCard",
        "maestro",
        "discover"
    ],
    badgeIdsExcludedBySaleStatus: [],
    bloomreach: {
        objectName: "br_data",
        viewId: "gb"
    },
    charactersNeededToSubmitSearch: 1,
    cookieConsent: {
        documentLanguage: true,
        provider: "OneTrust"
    },
    countryCode: "gb",
    countryName: "United Kingdom",
    currency: {
        code: "GBP",
        decimalsToDisplay: 2,
        symbol: "\xa3"
    },
    defaultPaymentMethod: constants/* PaymentMethod.SCHEME */.XL.SCHEME,
    emarsysMerchantId: "1754C0F32800C27F",
    fieldProps: (0,_object_spread/* default */.Z)({}, GBFieldProps),
    flag: "\uD83C\uDDEC\uD83C\uDDE7",
    forms: (0,_object_spread/* default */.Z)({}, GBForms),
    maxAgeCookiesExpires: constants/* MaxAgeExpiration.DAILY */.ho.DAILY,
    maxCountRecordKeeper: 0,
    myAccountDashboardConfiguration: [
        {
            childOrder: [
                "profileComponent",
                "passwordComponent",
                "preferencesComponent",
                "ambassadorComponent", 
            ],
            name: "leftColumn"
        },
        {
            childOrder: [
                "addressBookComponent",
                "orderHistoryComponent"
            ],
            name: "rightColumn"
        }, 
    ],
    newsletter: {
        contactSources: {
            checkOut: "5",
            footer: "1",
            signUp: "6"
        },
        fields: {
            gender: {
                required: true,
                values: [
                    "male",
                    "female",
                    "noAnswer"
                ]
            }
        }
    },
    orderLookUpQuery: types/* OrderSearchOperationName.SearchOrderByEmail */.G.SearchOrderByEmail,
    orderedPaymentPartners: [
        "visa",
        "master",
        "maestro",
        "payPal",
        "applePay",
        "klarna", 
    ],
    paymentMethodsMixedWithGiftCard: [
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT, 
    ],
    pdpVideosConfig: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.pdpVideosConfig), {
        numberOfLoops: 2,
        posterSecond: 4
    }),
    pixleeId: {
        en: "19802791"
    },
    priceInputMaxLength: 4,
    priceSliderInterval: 5,
    pumaAppDownloadUrl: "https://app.puma.com/web-download-uk",
    region: "europe",
    regionCode: "GBR",
    savedCreditCardTemplate: [
        "new",
        "saved"
    ],
    searchEngineIndexableLanguages: [
        constants/* SUPPORTED_LANGUAGE.EN */.lF.EN
    ],
    searchSymbolsMinValue: 2,
    selectablePaymentMethods: [
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.AMBASSADOR_CARD */.XL.AMBASSADOR_CARD,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT, 
    ],
    socialMediaLinks: {
        instagram: "https://instagram.com/puma.uk?igshid=YzAyZWRlMzg="
    },
    staticFeatures: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.staticFeatures), {
        addAddressResultErrorDisabled: true,
        allowGuestAccessToOrderDetails: true,
        ambassadorCardsEnabled: true,
        canRemoveWishlistItemsFromPDP: true,
        delayForterLoad: true,
        displayPromoDiscountBreakdown: false,
        editPasswordResultErrorDisabled: true,
        enableModelMeasurements: true,
        hideEmailNotifications: true,
        hidePickUpWhereYouLetOff: true,
        multipleModelMeasurementEnabled: true,
        parcelLabTrackingEnabled: true,
        popoverLoginEnabled: true,
        productFilterCollapsible: false,
        quickAddressFinder: false,
        removeReturnIframe: true,
        returnsOnOrderDetailsPage: true,
        showAddAddressButtonInAccountDashboard: false,
        showCookieBanner: false,
        showCookieConsentLayer: true,
        showFinancialIncentivesLink: false,
        showFreeShippingCost: true,
        showHeaderSubHeaderProductDetail: false,
        showModifiedResetPassFormPopup: false,
        showNewsletterSignupOnOrderConfirmation: false,
        showOrderSummaryAtOrderHistory: true,
        showOrderTrackingNumberInOrderDetails: true,
        showPaymentPartnersInFooter: true,
        showPhoneInCheckout: false,
        showPinterestFooterIcon: true,
        showPriceDifference: true,
        showPromoExclusionMsgInBaseSize: true,
        showTimeZoneName: true,
        singInInConfirmationForm: true,
        personalizationEnabled: true,
        ukAddressForm: true,
        useNewPaymentForm: true,
        useVerticalMedia: true,
        useDataguard: true
    }),
    supportedLocales: [
        "en-gb"
    ],
    validation: {
        address: {
            length: config.commonConfig.validation.address.length,
            line1: "^[a-zA-Z0-9\xc1\xe1\xc9\xe9\xcd\xed\xd3\xf3\xda\xfa\xdc\xfc\\-/ ' ]*$",
            line2: "^[a-zA-Z0-9-/ ]*$"
        },
        companyName: {
            length: {
                max: 50,
                min: 0
            }
        },
        email: "^[\\w.%+-]+@[\\w.-]+\\.[\\w]{2,6}$",
        name: {
            length: config.commonConfig.validation.name.length
        },
        password: "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#$%^&*.+(){}~?])(?=.{12,})",
        phone: {
            length: {
                max: 30,
                min: config.commonConfig.validation.phone.length.min
            },
            regex: "^.*$"
        },
        postalCode: {
            GB: "^(GIR[ ]?0AA)|((([ABCDEFGHIJKLMNOPRSTUWYZ][0-9][0-9]?)|(([ABCDEFGHIJKLMNOPRSTUWYZ][ABCDEFGHKLMNOPQRSTUVWXY][0-9][0-9]?)|(([ABCDEFGHIJKLMNOPRSTUWYZ][0-9][ABCDEFGHJKSTUW])|([ABCDEFGHIJKLMNOPRSTUWYZ][ABCDEFGHKLMNOPQRSTUVWXY][0-9][ABEHMNPRVWXY]))))[ ]?[0-9][ABDEFGHJLNPQRSTUWXYZ]{2})$"
        }
    }
});


/***/ })

}]);